export const buildinfo = {
    timeStamp: '2026_10_29_26.1299.1',
};
